import { PayloadAction } from '@reduxjs/toolkit';

export type CrudStatus<T> = {
  _status: {
    [K in keyof T]?: {
      success?: string | null;
      error?: string | null;
      lastUpdated?: string;
      hasFetched?: boolean;
      isFetching?: boolean;
      isUnauthorized?: boolean;
    };
  };
};

export const crudSlice: CrudStatus<any> = {
  _status: {},
};

type CrudAction<T> = PayloadAction<{ message?: string | null; attribute: keyof T }>;

export const crudReducer = <T>() => ({
  setPending: (state: CrudStatus<T>, action: CrudAction<T>) => {
    const { payload } = action;
    try {
      if (!state?._status[payload.attribute]) {
        state._status[payload.attribute] = {};
      }
      state._status[payload.attribute]!.isFetching = true;
      state._status[payload.attribute]!.hasFetched = false;
      state._status[payload.attribute]!.error = null;
      state._status[payload.attribute]!.success = null;
      state._status[payload.attribute]!.isUnauthorized = false;
    } catch (error) {
      console.error(error);
    }
  },
  setFulfilled: (state: CrudStatus<T>, action: CrudAction<T>) => {
    const { payload } = action;
    try {
      if (!state?._status[payload.attribute]) {
        state._status[payload.attribute] = {};
      }
      state._status[payload.attribute]!.isFetching = false;
      state._status[payload.attribute]!.hasFetched = true;
      state._status[payload.attribute]!.success = payload.message;
      state._status[payload.attribute]!.error = null;
      state._status[payload.attribute]!.isUnauthorized = false;
      state._status[payload.attribute]!.lastUpdated = new Date().toISOString();
    } catch (error) {
      console.error(error);
    }
  },
  setRejected: (state: CrudStatus<T>, action: CrudAction<T>) => {
    const { payload } = action;
    try {
      if (!state?._status[payload.attribute]) {
        state._status[payload.attribute] = {};
      }
      state._status[payload.attribute]!.isFetching = false;
      state._status[payload.attribute]!.hasFetched = true;
      state._status[payload.attribute]!.error = payload.message;
      state._status[payload.attribute]!.success = null;
      state._status[payload.attribute]!.isUnauthorized = false;
      state._status[payload.attribute]!.lastUpdated = new Date().toISOString();
    } catch (error) {
      console.error(error);
    }
  },
  setUnauthorized: (state: CrudStatus<T>, action: CrudAction<T>) => {
    const { payload } = action;
    try {
      if (!state?._status[payload.attribute]) {
        state._status[payload.attribute] = {};
      }
      state._status[payload.attribute]!.isFetching = false;
      state._status[payload.attribute]!.hasFetched = false;
      state._status[payload.attribute]!.error = 'Unauthorized';
      state._status[payload.attribute]!.success = null;
      state._status[payload.attribute]!.isUnauthorized = true;
      state._status[payload.attribute]!.lastUpdated = new Date().toISOString();
    } catch (error) {
      console.error(error);
    }
  },
});
